import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeEvaluationFeedbackCriteria,
  createEvaluationFeedbackCriteria,
  deleteEvaluationFeedbackCriteria,
  getEvaluationFeedbackCriteria,
  inactiveEvaluationFeedbackCriteria,
  listEvaluationFeedbackCriteria,
  updateEvaluationFeedbackCriteria,
} from 'api/feedback/feedback.api';
import {
  ActiveEvaluationFeedbackCriteriaRequestModel,
  DeleteEvaluationFeedbackCriteriaRequestModel,
  GetEvaluationFeedbackCriteriaRequestModel,
  InactiveEvaluationFeedbackCriteriaRequestModel,
  ListEvaluationFeedbackCriteriaRequestModel,
  SaveEvaluationFeedbackCriteriaRequestModel,
} from 'models/feedback/feedback.model';

export const getEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'GET_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (payload: GetEvaluationFeedbackCriteriaRequestModel) =>
    getEvaluationFeedbackCriteria(payload),
);

export const listEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'LIST_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (payload: ListEvaluationFeedbackCriteriaRequestModel) =>
    listEvaluationFeedbackCriteria(payload),
);

export const createEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'CREATE_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (
    payload: SaveEvaluationFeedbackCriteriaRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await createEvaluationFeedbackCriteria(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'UPDATE_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (
    payload: SaveEvaluationFeedbackCriteriaRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await updateEvaluationFeedbackCriteria(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'DELETE_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (
    payload: DeleteEvaluationFeedbackCriteriaRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await deleteEvaluationFeedbackCriteria(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'INACTIVE_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (
    payload: InactiveEvaluationFeedbackCriteriaRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await inactiveEvaluationFeedbackCriteria(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeEvaluationFeedbackCriteriaAction = createAsyncThunk(
  'ACTIVE_EVALUATIION_FEEDBACK_CRITERIA_REQUEST',
  async (
    payload: ActiveEvaluationFeedbackCriteriaRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await activeEvaluationFeedbackCriteria(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
